<template>
  <div v-if="message" class="credit-next">
    <p>{{ message }}</p>
    <div class="actions">
      <router-link v-if="kind === 'login'" to="/account?mode=login">登录 / 注册</router-link>
      <button v-else-if="kind === 'points'" type="button" @click.stop="openFollow">关注送积分</button>
    </div>
  </div>
</template>

<script>
import { openFollowBonus } from '../utils/authBus'

export default {
  name: 'CreditNext',
  props: {
    message: { type: String, default: '' },
    status: { type: Number, default: 0 }
  },
  computed: {
    kind() {
      if (this.status === 401) return 'login'
      if (this.status === 402) return 'points'
      return ''
    }
  },
  methods: {
    openFollow() {
      openFollowBonus()
    }
  }
}
</script>

<style scoped>
.credit-next {
  margin: 0 0 12px;
  padding: 10px 12px;
  background: #fff7e8;
  border: 1px solid #ffe4ba;
  border-radius: 12px;
  color: #4e5969;
  font-size: 13px;
  line-height: 1.5;
}
.credit-next p { margin: 0; }
.actions { margin-top: 8px; }
.actions a,
.actions button {
  border: 0;
  background: #165dff;
  color: #fff;
  border-radius: 999px;
  padding: 6px 10px;
  font-size: 13px;
  cursor: pointer;
  text-decoration: none;
  display: inline-block;
}
</style>
